import SidebarPanelItemDescription from "entities/shared/sidebar-panel-item/description";
import StandardProductAmount, {
  StandardProductAmountType,
} from "features/shared/standard-product/amount";
import {
  CheckoutTabIds,
  useCheckoutTabsContext,
} from "pages/checkout/providers/CheckoutTabsProvider";
import { CategoryStandardProduct } from "shared/api/middleware-api-client";
import { concatClassnames } from "shared/utils/concatClassnames";

interface Props {
  standardProduct: CategoryStandardProduct;
  index: number;
  className?: string;
  setPanelAmount: (amount: number) => void;
}

const SidebarStandardProduct = ({
  standardProduct,
  index,
  className,
  setPanelAmount,
}: Props) => {
  const { currentTab } = useCheckoutTabsContext();

  return (
    <div
      className={concatClassnames(
        "gg-grid gg-grid-cols-12 gg-items-start",
        className,
      )}
    >
      <SidebarPanelItemDescription
        className="gg-col-span-12"
        standardProduct={standardProduct}
      />
      <StandardProductAmount
        type={StandardProductAmountType.BACKGROUND}
        amount={standardProduct.amount}
        setAmount={setPanelAmount}
        className={concatClassnames(
          "gg-mt-5 lg:gg-col-start-5",
          currentTab.id !== CheckoutTabIds.OVERVIEW && "gg-hidden",
        )}
      />
    </div>
  );
};
export default SidebarStandardProduct;
